export default "__VITE_ASSET__DyP9O8Wt__"